<template>

  <div class="py-4 container-fluid">
    <div class="row">

      <div class="col-md-8">
        <div class="card mb-2">
          <div class="card-header pb-0">
            <div class="d-flex align-items-center">
              <p class="mb-0">Crear Producto</p>
              <argon-button color="success" size="sm" class="ms-auto" @click="save" :disabled="isSaving">Guardar</argon-button>
            </div>
          </div>
          <div class="card-body">
            <p class="text-uppercase text-sm">Información</p>
            <div class="row">
              <div class="col-md-8">
                <label for="example-text-input" class="form-control-label">Nombre</label>
                <argon-input type="text" v-model="form.name" />
              </div>

              <div class="col-md-4">
                <label for="example-text-input" class="form-control-label">Referencia</label>
                <argon-input type="text" v-model="form.ref" />
              </div>

              <div class="col-md-12">
                <label for="example-text-input" class="form-control-label">Descripción</label>
                <argon-textarea type="text" v-model="form.description" />
              </div>

              <div class="col-md-6">
                <label for="example-text-input" class="form-control-label">Stock</label>
                <argon-input type="text" v-model="form.quantity" />
              </div>

              <div class="col-md-6">
                <label for="example-text-input" class="form-control-label">Precio de compra</label>
                <argon-input type="text" v-model="form.price" />
              </div>

              

              <div class="col-md-12 d-flex align-items-center mt-4 mb-4">
                <div class="form-check form-switch">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    id="manageStock"
                    v-model="form.manage_stock"
                  />
                  <label class="form-check-label ms-2" for="manageStock">
                    Manejar stock del insumo
                  </label>
                </div>
              </div>

              <div class="col-md-12 mt-3">
                <div class="card card-semaforo border shadow-none mb-0">
                  <div class="card-body pt-3 pb-3">
                    <p class="text-sm mb-3 semaforo-info">
                      Estos campos se usan como <strong>semáforo</strong> de stock: en rojo cuando el inventario está bajo,
                      en amarillo en nivel medio y en verde cuando el stock es alto.
                    </p>
                    <div class="row">
                      <div class="col-md-4">
                        <label for="supply-low" class="form-control-label d-flex align-items-center mb-2">
                          <span class="semaforo-dot semaforo-dot--rojo me-2" aria-hidden="true"></span>
                          Cant mínima
                        </label>
                        <argon-input id="supply-low" type="text" v-model="form.low" />
                      </div>

                      <div class="col-md-4">
                        <label for="supply-medium" class="form-control-label d-flex align-items-center mb-2">
                          <span class="semaforo-dot semaforo-dot--amarillo me-2" aria-hidden="true"></span>
                          Cant media
                        </label>
                        <argon-input id="supply-medium" type="text" v-model="form.medium" />
                      </div>

                      <div class="col-md-4">
                        <label for="supply-high" class="form-control-label d-flex align-items-center mb-2">
                          <span class="semaforo-dot semaforo-dot--verde me-2" aria-hidden="true"></span>
                          Cant alta
                        </label>
                        <argon-input id="supply-high" type="text" v-model="form.high" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-md-6">
                <label for="example-text-input" class="form-control-label">Bodega</label>
                <select name="" id="" class="form-select" v-model="form.bodega_id">
                  <option value="">Seleccionar</option>
                  <option v-for="bodega in bodegas" :key="bodega.id" :value="bodega.id">
                    {{ bodega.name }}
                  </option>
                </select>
              </div>

              <div class="col-md-6">
                <label for="example-text-input" class="form-control-label">Estado</label>
                <select name="" id="" class="form-select" v-model="form.status">
                  <option value="0">Inactivo</option>
                  <option value="1">Activo</option>
                </select>
              </div>

            </div>
          </div>
        </div>

      </div>

      <div class="col-12" v-if="form.id!=0">
        <div class="card">

          <div class="card-header pb-0">
            <div class="d-flex align-items-center">
              <h6>Lista de novedades</h6>
              <argon-button color="success" size="sm" class="ms-auto" @click="openModal">Agregar
                novedad</argon-button>
            </div>
          </div>

          <div class="card-body px-0 pt-0 pb-2">
            <div class="table-responsive p-0">

              <table class="table align-items-center mb-0">
                <thead>
                  <tr>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                      Cantidad</th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                      Observación
                    </th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                      Fecha de creación
                    </th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                      Opciones
                    </th>

                  </tr>
                </thead>
                <tbody>
                  <tr v-for="value in data" :key="value.id">

                    <!-- Cantidad -->
                    <td class="align-middle text-center text-sm">
                      {{ value.quantity_change }}
                    </td>

                    <!-- Observación -->
                    <td class="align-middle text-center">
                      <span class="text-secondary text-xs font-weight-bold">
                        <a @click="viewObservation(value.observation)"
                          class="text-secondary font-weight-bold text-xs cursor-pointer" data-toggle="tooltip"
                          data-original-title="Registro">
                          <i class="fa fa-comment"></i>
                        </a>
                      </span>
                    </td>

                    <!-- created_at -->
                    <td class="align-middle text-center text-sm">
                      <div class="d-flex justify-content-center">
                        <h6 class="mb-0 text-sm">
                          {{ new Date(value.created_at).toLocaleDateString('es-ES') }}
                        </h6>
                      </div>
                    </td>

                    <!-- opciones -->
                    <td class="align-middle text-center">

                      <!-- Editar -->
                      <a @click="editRegister(value)" class="text-secondary font-weight-bold text-xs cursor-pointer"
                        data-toggle="tooltip" data-original-title="Editar registro">
                        <i class="fa fa-pencil-alt"></i>
                      </a>

                      <!-- Eliminar -->
                      <a @click="deleteRegister(value.id)"
                        class="text-secondary font-weight-bold text-xs cursor-pointer" style="margin-left: 15px;"
                        data-toggle="tooltip" data-original-title="Eliminar registro">
                        <i class="fa fa-trash"></i>
                      </a>

                    </td>
                  </tr>

                  <tr v-if="data.length === 0">
                    <td colspan="7" class="text-center text-xxs">No hay registros disponibles</td>
                  </tr>

                </tbody>
              </table>

              <!-- Paginación -->
              <div class="pagination p-3">
                <!-- Recorremos los links para generar los botones -->
                <a v-for="link in links" :key="link.label" class="page-item cursor-pointer"
                  @click="fetchData(link.label)" :disabled="!link.url || link.active"
                  :class="{ 'active': link.label === currentPage.toString() }">
                  {{ link.label }}
                </a>
              </div>

            </div>
          </div>
        </div>
      </div>

    </div>

    <!-- Modal -->
    <div class="modal fade" id="ModalBudget" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content card">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">Agregar novedad</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <form>

              <div class="mb-3">
                <label for="amount" class="form-label">Cantidad</label>
                <input type="number" v-model="modal.quantity_change" id="total_price" class="form-control"
                  placeholder="Ingrese el valor total">
              </div>

              <div class="mb-3">
                <label for="observation" class="form-label">Observación</label>
                <textarea v-model="modal.observation" id="observation" class="form-control"
                  placeholder="Ingrese la observación"></textarea>
              </div>

            </form>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" @click="closeModal">Cerrar</button>
            <button type="button" class="btn btn-primary" @click="submitForm">Guardar</button>
          </div>
        </div>
      </div>
    </div>
    <!-- Modal -->

  </div>

</template>

<script>
import setNavPills from "../../../assets/js/nav-pills.js";
import setTooltip from "../../../assets/js/tooltip.js";
import ArgonInput from "../../../components/ArgonInput.vue";
import ArgonTextarea from "../../../components/ArgonTextarea.vue";
import ArgonButton from "../../../components/ArgonButton.vue";
import { useRoute } from "vue-router";
import Swal from 'sweetalert2';
import 'select2/dist/css/select2.css';
import 'select2';
import { Modal } from 'bootstrap';
import { mapGetters } from 'vuex';

const body = document.getElementsByTagName("body")[0];

export default {
  name: "Models Create",
  data() {
    return {
      showMenu: false,
      isSaving: false,
      form: {
        id: 0,
        name: '',
        ref: '',
        description: '',
        quantity: 0,
        status: 0,
        bodega_id: 0,
        price: 0,
        manage_stock: true,
        low: 0,
        medium: 0,
        high: 0,
      },
      modal: {
        id: 0,
        inventory_id: 0,
        quantity_change: 0,
        observation: '',
      },
      bodegas: [],
      users: [],
    };
  },
  components: { ArgonInput, ArgonTextarea, ArgonButton },
  computed: {
    ...mapGetters('inventoryNews', ['allData', 'currentPage', 'lastPage', 'pagination', 'links']), // Mapea el getter allUsers
    currentPage() {
      return this.$store.state.inventoryNews.currentPage; // Obtiene la página actual
    },
    lastPage() {
      return this.$store.state.inventoryNews.lastPage; // Obtiene la última página
    },
    data() {
      return this.allData; // Retorna los usuarios desde el store
    },
    links() {
      return this.$store.getters['inventoryNews/links']; // Retorna los links
    },
  },
  methods: {
    normalizeBoolean(value) {
      if (value === undefined || value === null) {
        return true;
      }
      if (typeof value === 'string') {
        return value === '1' || value.toLowerCase() === 'true';
      }
      return value === 1 || value === true;
    },
    async fetchData(pageUrl = null) {

      const params = {
        inventory_id: this.form.id,
        page: pageUrl
      };
      await this.$store.dispatch('inventoryNews/fetchData', params);
    },
    async getBodegas() {
      this.bodegas = await this.$store.dispatch('bodegas/getAll');
    },
    async save() {
      // Evitar doble guardado
      if (this.isSaving) {
        return;
      }

      try {
        // Activar estado de guardado
        this.isSaving = true;

        // Mostrar modal de carga
        Swal.fire({
          title: 'Guardando...',
          allowOutsideClick: false,
          allowEscapeKey: false,
          showConfirmButton: false,
          didOpen: () => {
            Swal.showLoading();
          }
        });

        // Dispara la acción de Vuex para guardar el estudiante
        const response = await this.$store.dispatch("inventory/save", this.form);
        
        // Cerrar modal de carga
        Swal.close();

        if (response && response.status >= 200 && response.status < 300) {
          // Actualizar el formulario con los datos guardados
          if (response.data && response.data.data) {
            this.form.id = response.data.data.id || this.form.id;
          }
          
          await Swal.fire({
            icon: 'success',
            title: '¡Éxito!',
            text: 'El proyecto ha sido guardado correctamente.',
            confirmButtonText: 'Aceptar',
            backdrop: true,
          });

        } else {
          throw new Error(response.data.message || 'Error al guardar el proyecto');
        }

      } catch (error) {
        // Cerrar modal de carga en caso de error
        Swal.close();
        console.error("Error al crear el proyecto:", error);
        const errData = error?.data || error?.response?.data;
        const msg = errData?.errors?.ref?.[0] || errData?.message || error?.message || 'Error al guardar el proyecto';
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: msg,
        });
      } finally {
        // Desactivar estado de guardado
        this.isSaving = false;
      }
    },
    openModal() {
      const modalElement = document.getElementById('ModalBudget');
      this.modalBudget = new Modal(modalElement); // Guarda la instancia del modal
      this.modalBudget.show(); // Muestra el modal
    },
    closeModal() {
      if (this.modalBudget) {
        this.modalBudget.hide(); // Cierra el modal
      }
    },
    async submitForm() {
      try {
        this.modal.inventory_id = this.form.id;
        // Dispara la acción de Vuex para guardar el modal
        const response = await this.$store.dispatch("inventoryNews/save", this.modal);

        if (response && response.status >= 200 && response.status < 300) {
          await Swal.fire({
            icon: 'success',
            title: '¡Éxito!',
            text: 'El registro ha sido guardado correctamente.',
            confirmButtonText: 'Aceptar',
            backdrop: true,
          }).then((result) => {
            if (result.isConfirmed) {
              this.modal.quantity_change = 0;
              this.modal.observation = '';

              //console.log(response);
              this.form.quantity = parseFloat(response.data.data.stock)||0;

              this.closeModal();
              this.fetchData();
            }
          });
        } else {
          throw new Error(response.data.message || 'Error al guardar el registro');
        }

      } catch (error) {
        console.error("Error al crear el registro:", error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.message || 'Error al guardar el registro',
        });
      }

    },
    async editRegister(data) {
      this.modal = data;
      this.openModal();
    },
    async deleteRegister(userId) {
      try {
        const result = await Swal.fire({
          title: '¿Estás seguro?',
          text: 'Esta acción no se puede deshacer.',
          icon: 'warning',
          showCancelButton: false,
          confirmButtonColor: '#d33',
          cancelButtonColor: '#3085d6',
          confirmButtonText: 'Sí, eliminar!',
          cancelButtonText: 'Cancelar'
        });

        if (result.isConfirmed) {
          const response = await this.$store.dispatch("inventoryNews/delete", userId);
          if (response && response.status >= 200 && response.status < 300) {

            await Swal.fire(
              'Eliminado!',
              'El registro ha sido eliminado correctamente.',
              'success'
            );

            this.fetchData();
          } else {
            throw new Error(response.data.message || 'Error al eliminar el registro');
          }
        }
      } catch (error) {
        console.error("Error al eliminar el registro:", error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.message || 'Error al eliminar el registro',
        });
      }
    },
    viewObservation(observation) {
      // Mostramos el mensaje en un SweetAlert
      Swal.fire({
        title: 'Observación',
        text: observation || 'No hay observaciones disponibles.',
        icon: 'info',  // Puedes cambiar el icono a info, success, warning, etc.
        confirmButtonText: 'Aceptar'
      });
    },

  },
  mounted() {

    this.getBodegas();


    const route = useRoute();
    const dataEdit = route.params.data;

    console.log(dataEdit);

    if (dataEdit) {
      try {
        const params = JSON.parse(dataEdit); // Asegúrate de que este JSON se pueda parsear


        if (params && params.id) {
          this.form = {
            ...this.form,
            ...params,
            manage_stock: this.normalizeBoolean(params.manage_stock),
          };
          this.fetchData();
        }
      } catch (error) {
        console.error("Error al parsear los datos del registro:", error);
      }
    }

    this.$store.state.isAbsolute = false;
    setNavPills();
    setTooltip();
  },
  beforeMount() {
    this.$store.state.imageLayout = "profile-overview";
    this.$store.state.showNavbar = true;
    this.$store.state.showFooter = true;
    this.$store.state.hideConfigButton = true;
    body.classList.add("profile-overview");
  },
  beforeUnmount() {
    this.$store.state.isAbsolute = false;
    this.$store.state.imageLayout = "default";
    this.$store.state.showNavbar = true;
    this.$store.state.showFooter = true;
    this.$store.state.hideConfigButton = false;
    body.classList.remove("profile-overview");
  }
};
</script>

<style>
.disabled-link {
  color: gray;
  pointer-events: none;
  /* Impide la interacción */
  cursor: not-allowed;
  /* Cambia el cursor para indicar que está deshabilitado */
}

.pagination {
  display: flex;
  justify-content: center;
  margin-top: 20px;
}

.page-item {
  margin: 0 5px;
}

.active {
  font-weight: bold;
  /* Estilo para la página activa */
}

.card-semaforo {
  background-color: #f8f9fa;
}

.semaforo-info {
  color: #67748e;
}

.semaforo-dot {
  display: inline-block;
  width: 12px;
  height: 12px;
  min-width: 12px;
  border-radius: 50%;
  flex-shrink: 0;
}

.semaforo-dot--rojo {
  background-color: #ea0606;
}

.semaforo-dot--amarillo {
  background-color: #f5a623;
}

.semaforo-dot--verde {
  background-color: #82d616;
}
</style>
